import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isStaff, can } from "@/lib/permissions";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, staffOnly = false, module = null }) => {
  const { user, loading } = useAuth();
  const needsStaff = staffOnly || !!module;

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#f8faf8]">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-700" />
      </div>
    );
  }
  if (!user) return <Navigate to={needsStaff ? "/admin/login" : "/login"} replace />;
  if (needsStaff && !isStaff(user.role)) return <Navigate to="/dashboard" replace />;
  // Role-level page guard: redirect staff who lack this module to their console
  if (module && !can(user.role, module, "view")) return <Navigate to="/admin" replace />;
  return children;
};
